<div class="border-bottom-1 border-300 p-3 mb-1 relative" *ngIf="showInfo$ && !(showSkeleton$ | async)" data-testid="upgrade-membership-info">
  <div class="h-5rem absolute left-0 top-0 mt-3 ml-2">
      <p-divider layout="vertical"></p-divider>
  </div>

  <!-- Form Group -->
  <div class="mb-5 relative pl-5" data-testid="from-subscription-section">
      <div class="h-1rem w-1rem border-circle bg-red absolute left-0 top-0"></div>
      <label class="font-medium text-700 text-xs mb-1 block uppercase" id="from-subscription-label">{{'UPGRADE.FROM' | translate}}</label>
      <strong class="block" aria-labelledby="from-subscription-label" data-testid="from-subscription-name">{{ authService.getLocalizedFieldData(fromSubscription.name_primary_language,fromSubscription.name_secondary_language) | async}}</strong>
  </div>
  <!-- Form Group -->

  <!-- Form Group -->
  <div class="relative pl-5" data-testid="to-subscription-section">
      <div class="h-1rem w-1rem border-circle bg-green-600 absolute left-0 top-0"></div>
      <label class="font-medium text-700 text-xs mb-1 block uppercase" id="to-subscription-label">{{'UPGRADE.TO' | translate}}</label>
      <strong class="block" aria-labelledby="to-subscription-label" data-testid="to-subscription-name">{{ authService.getLocalizedFieldData(planMaster.name_primary_language,planMaster.name_secondary_language) | async}}</strong>
  </div>
  <!-- Form Group -->
</div>

<div *ngIf="showInfo$ && (showSkeleton$ | async)" class="border-bottom-1 border-300 p-3 mb-1 relative" data-testid="upgrade-membership-info-skeleton">
  <div class="h-5rem absolute left-0 top-0 mt-3 ml-2">
      <p-divider layout="vertical"></p-divider>
  </div>

  <!-- Form Group -->
  <div class="mb-5 relative pl-5" data-testid="from-subscription-skeleton">
      <div class="h-1rem w-1rem border-circle bg-red absolute left-0 top-0"></div>
      <label class="font-medium text-700 text-xs mb-1 block uppercase">{{'UPGRADE.FROM' | translate}}</label>
      <p-skeleton height="1.35rem" styleClass="w-10rem"></p-skeleton>
  </div>
  <!-- Form Group -->

  <!-- Form Group -->
  <div class="relative pl-5" data-testid="to-subscription-skeleton">
      <div class="h-1rem w-1rem border-circle bg-green-600 absolute left-0 top-0"></div>
      <label class="font-medium text-700 text-xs mb-1 block uppercase">{{'UPGRADE.TO' | translate}}</label>
      <p-skeleton height="1.35rem" styleClass="w-10rem"></p-skeleton>
  </div>
  <!-- Form Group -->
</div>

<div class="p-3" *ngIf="showInfo$" data-testid="plan-details-container">
  <!-- Card -->
  <div class="surface-0 border-round shadow-1 px-3 pt-3 pb-2" data-testid="plan-details-card">
      <div class="flex align-items-center mb-2" *ngIf="!(showSkeleton$ | async)" data-testid="plan-header">
          <div class="bg-blue-50 border-1 border-primary border-round text-primary text-center uppercase px-2 py-1 inline-block text-xs" data-testid="subscription-category">
              {{planMaster.subscription_category}}
          </div>
          <strong class="ml-2" data-testid="plan-name">{{ authService.getLocalizedFieldData(planMaster.name_primary_language,planMaster.name_secondary_language) | async}}</strong>
      </div>
      <p-skeleton *ngIf="showSkeleton$ | async" styleClass="w-6rem mb-2" height="1.35rem" data-testid="plan-header-skeleton"></p-skeleton>

      <p class="text-500 mb-2 border-bottom-1 border-300 pb-3 text-xs" *ngIf="!(showSkeleton$ | async)" data-testid="plan-description">
          {{authService.getLocalizedFieldData(planMaster.description_primary_language,planMaster.description_secondary_language) | async}}
      </p>
      <p-skeleton *ngIf="showSkeleton$ | async" styleClass="w-6rem mb-2" height="1.35rem" data-testid="plan-description-skeleton"></p-skeleton>

      <!-- Grid -->
      <div class="grid" data-testid="plan-dates-container">
          <!-- Form Group -->
          <div class="col-6" data-testid="start-date-section">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" id="start-date-label"> {{'POS.MEMBERSHIP_ADDON.START_DATE' | translate}}</label>
              <strong aria-labelledby="start-date-label" data-testid="subscription-start-date">{{subscriptionStartDate | date: 'MMM dd, yyyy'}}</strong>
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="col-6" data-testid="upgrade-date-section">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" id="upgrade-date-label">{{'UPGRADE.UPGRADE_DATE' | translate}}</label>
              <strong aria-labelledby="upgrade-date-label" data-testid="upgrade-date">{{ UpgradeDate | date: 'MMM dd, yyyy' }}</strong>
          </div>
          <!-- Form Group -->
      </div>
      <!-- Grid -->
  </div>
  <!-- Card -->
</div>

<!-- Upgrade Calculation -->
<div class="mt-4 px-3 pb-3 relative" *ngIf="showCalculation$ && !(showSkeleton$ | async) && (upgardePlanBreakUpResponse$ | async) as breakup" data-testid="upgrade-calculation-container">
  <label class="font-medium text-700 text-xs mb-3 block uppercase border-bottom-1 border-300 pb-2" id="upgrade-calculation-label">{{'UPGRADE.UPGARDE_CALCULATION' | translate}}</label>
  <div class="h-4rem absolute right-0 top-0 mt-6 mr-2">
      <p-divider layout="vertical"></p-divider>
  </div>
  <!-- Form Group -->
  <div class="mb-5 relative pr-5" *ngIf="!(showSkeleton$ | async)" data-testid="upgrade-to-amount-section">
      <div class="h-1rem w-1rem border-circle bg-green-600 absolute right-0 top-0"></div>
      <div class="flex align-items-center justify-content-between">
          <div class="md:w-5 text-sm" data-testid="upgrade-to-amount"><strong>{{breakup.total_upgrade_to_amount | currencyformat}}</strong> 
            <!-- &nbsp; <span class="text-500 line-through">$500.00</span> -->
        </div>
          <div class="text-sm text-right">
              <div class="font-bold" data-testid="upgrade-to-plan-name">{{ authService.getLocalizedFieldData(planMaster.name_primary_language,planMaster.name_secondary_language) | async}}</div>
              <div class="text-600"><i class="fa fa-info-circle text-sm text-600 cursor-pointer mr-2" pTooltip="Lorem Ipsum" tooltipStyleClass="text-xs" aria-label="Information about pro rata"></i> <span data-testid="pro-rata-text">{{'UPGRADE.PRO_RETA' | translate}}</span></div>
          </div>
      </div>
  </div>
  <!-- Form Group -->

  <!-- Skeleton -->
  <div *ngIf="(showSkeleton$ | async)" class="mb-5 relative pr-5" data-testid="upgrade-to-amount-skeleton">
      <div class="h-1rem w-1rem border-circle bg-green-600 absolute right-0 top-0"></div>
      <div class="flex align-items-center justify-content-between">
          <div class="md:w-5 text-sm">
              <p-skeleton height="1.35rem" styleClass="w-5rem"></p-skeleton>
          </div>
          <div class="text-sm text-right">
              <p-skeleton height="1.35rem" styleClass="w-10rem" styleClass="mb-1"></p-skeleton>
              <p-skeleton height="1.35rem" styleClass="w-15rem"></p-skeleton>
          </div>
      </div>
  </div>
  <!-- Skeleton -->

  <!-- Form Group -->
  <div class="relative mb-3 pr-5" *ngIf="!(showSkeleton$ | async)" data-testid="from-invoice-amount-section">
      <div class="h-1rem w-1rem border-circle bg-red absolute right-0 top-0"></div>
      <div class="flex align-items-center justify-content-between">
          <div class="md:w-5">
              <strong class="text-sm p-error mr-2" data-testid="from-invoice-amount">(-) {{breakup.from_invoice_amount | currencyformat}}</strong>
          </div>
          <div class="text-sm text-right">
              <div class="font-bold" data-testid="from-plan-name">{{ authService.getLocalizedFieldData(fromSubscription.name_primary_language,fromSubscription.name_secondary_language) | async}}</div>
              <div class="text-600"><i class="fa fa-info-circle text-sm text-600 cursor-pointer mr-2" pTooltip="Lorem Ipsum" tooltipStyleClass="text-xs" aria-label="Information about carried over amount"></i> <span data-testid="carried-over-text">{{'UPGRADE.CARRIED_OVER' | translate}}</span></div>
          </div>
      </div>
  </div>
  <!-- Form Group -->
  <!-- Skeleton -->
  <div *ngIf="(showSkeleton$ | async)" class="mb-5 relative pr-5" data-testid="from-invoice-amount-skeleton">
      <div class="h-1rem w-1rem border-circle bg-green-600 absolute right-0 top-0"></div>
      <div class="flex align-items-center justify-content-between">
          <div class="md:w-5 text-sm">
              <p-skeleton height="1.35rem" styleClass="w-5rem"></p-skeleton>
          </div>
          <div class="text-sm text-right">
              <p-skeleton height="1.35rem" styleClass="w-10rem" styleClass="mb-1"></p-skeleton>
              <p-skeleton height="1.35rem" styleClass="w-15rem"></p-skeleton>
          </div>
      </div>
  </div>
  <!-- Skeleton -->

  <!-- Form Group -->
  <div class="border-top-1 border-bottom-1 border-300 py-2" *ngIf="!(showSkeleton$ | async)" data-testid="total-amount-section">
      <div class="flex align-items-center justify-content-between">
        <div class="md:w-5 text-sm">
          <strong class="md:text-lg" data-testid="final-payment-amount">{{ (breakup.upgrade_diff_amount - breakup.upgrade_discount_amount) | currencyformat}}</strong>
          &nbsp; <span *ngIf="breakup.upgrade_discount_amount && breakup.upgrade_discount_amount > 0" class="text-500 line-through" data-testid="discount-amount">
            {{ breakup.upgrade_discount_amount | currencyformat }}
          </span>
        </div>
          <strong class="text-sm text-right" data-testid="diff-amount-label">{{'UPGRADE.DIIF_AMOUNT_TO_PAY' | translate }}</strong>
      </div>
  </div>
  <!-- Form Group -->

  <!-- Skeleton -->
  <div *ngIf="(showSkeleton$ | async)" class="border-top-1 border-bottom-1 border-300 py-2" data-testid="total-amount-skeleton">
      <div class="flex align-items-center justify-content-between">
          <p-skeleton height="1.35rem" styleClass="w-6rem"></p-skeleton>
          <p-skeleton height="1.35rem" styleClass="w-10rem"></p-skeleton>
      </div>
  </div>
  <!-- Skeleton -->
</div>

<div class="mt-4 px-3 pb-3 relative" *ngIf="showCalculation$ && (showSkeleton$ | async)" data-testid="upgrade-calculation-skeleton-container">
  <label class="font-medium text-700 text-xs mb-3 block uppercase border-bottom-1 border-300 pb-2">{{'UPGRADE.UPGARDE_CALCULATION' | translate}}</label>
  <div class="h-4rem absolute right-0 top-0 mt-6 mr-2">
      <p-divider layout="vertical"></p-divider>
  </div>

  <!-- Skeleton -->
  <div class="mb-5 relative pr-5" data-testid="upgrade-to-amount-skeleton-item">
      <div class="h-1rem w-1rem border-circle bg-green-600 absolute right-0 top-0"></div>
      <div class="flex align-items-center justify-content-between">
          <div class="md:w-5 text-sm">
              <p-skeleton height="1.35rem" styleClass="w-5rem"></p-skeleton>
          </div>
          <div class="text-sm text-right">
              <p-skeleton height="1.35rem" styleClass="w-10rem" styleClass="mb-1"></p-skeleton>
              <p-skeleton height="1.35rem" styleClass="w-15rem"></p-skeleton>
          </div>
      </div>
  </div>
  <!-- Skeleton -->

  <!-- Skeleton -->
  <div class="mb-5 relative pr-5" data-testid="from-invoice-amount-skeleton-item">
      <div class="h-1rem w-1rem border-circle bg-green-600 absolute right-0 top-0"></div>
      <div class="flex align-items-center justify-content-between">
          <div class="md:w-5 text-sm">
              <p-skeleton height="1.35rem" styleClass="w-5rem"></p-skeleton>
          </div>
          <div class="text-sm text-right">
              <p-skeleton height="1.35rem" styleClass="w-10rem" styleClass="mb-1"></p-skeleton>
              <p-skeleton height="1.35rem" styleClass="w-15rem"></p-skeleton>
          </div>
      </div>
  </div>
  <!-- Skeleton -->

  <!-- Skeleton -->
  <div class="border-top-1 border-bottom-1 border-300 py-2" data-testid="total-amount-skeleton-item">
      <div class="flex align-items-center justify-content-between">
          <p-skeleton height="1.35rem" styleClass="w-6rem"></p-skeleton>
          <p-skeleton height="1.35rem" styleClass="w-10rem"></p-skeleton>
      </div>
  </div>
  <!-- Skeleton -->
</div>
<!-- Upgrade Calculation -->
